import React from "react";

const PAIN_BUBBLES = [
  { icon: "💰", text: "You waste $$$ replacing flat pillows every 6 months", rotate: "-rotate-2", offset: "ml-0" },
  { icon: "🚫", text: "Neck pain & migraines wake you up before your alarm", rotate: "rotate-1", offset: "ml-12 md:ml-32" },
  { icon: "⏰", text: "You spend 8 hours in bed and still feel exhausted", rotate: "-rotate-1", offset: "ml-4 md:ml-16" },
  { icon: "🏨", text: "The only good pillow you'll ever sleep on costs $900/night at a hotel", rotate: "rotate-2", offset: "ml-16 md:ml-40" },
];

export default function ProblemSection() {
  return (
    <section className="aurora-wrap py-20 md:py-28">
      <div className="container-x">
        <div className="text-center">
          <span className="section-pill">ⓘ The problem</span>
          <h2 className="mt-6 text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
            You know great sleep would change your life…
            <br />
            <span className="text-[#4a6cff]">But every night</span> ends the same:
          </h2>
        </div>

        <div className="relative mt-14 md:mt-20 max-w-3xl mx-auto space-y-4 md:space-y-5">
          {PAIN_BUBBLES.map((b, i) => (
            <div
              key={i}
              className={`bubble-card ${b.rotate} ${b.offset}`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <span className="text-2xl flex-shrink-0">{b.icon}</span>
              <span className="text-[14px] md:text-[15px] text-[#2a2a2e] font-medium">
                {b.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
